import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreContext } from '../../Contexts/StoreContext';
import { TbInfoCircle } from 'react-icons/tb';

interface BoxContentSearchStoreByLocationProps {
    className?: string;
    show?: boolean;
}

const BoxContentSearchStoreByLocation = ({ className, show }: BoxContentSearchStoreByLocationProps) => {

    const { t } = useTranslation();
    const { currentStore } = useStoreContext();

    if (!currentStore || !show) {
        return null;
    }

    return (
        <div className={`flex px-4 items-center gap-0.5 text-xs text-gray-400 pb-2 ${className}`}>
            <span className="shrink-0">{<TbInfoCircle size={16} />}</span>
            <div className='leading-none'>{t('layout.store_list.search_by_location')}</div>
        </div>
    );
};

export default BoxContentSearchStoreByLocation;
